var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfiabilidadDitoPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_5",
    x: 0,
    y: 0,
    width: 196,
    height: 196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confiabilidad_Dito_Pay",
    "data-name": "Confiabilidad Dito Pay",
    transform: "translate(-383 -1787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 383, 1787)",
    filter: "url(#Elipse_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5-2",
    "data-name": "Elipse 5",
    cx: 89,
    cy: 89,
    r: 89,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "User_Unlocked-02-WF",
    "data-name": "User Unlocked-02-WF",
    transform: "translate(430 1825.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M70.31,67.5a2.812,2.812,0,0,1,2.812,2.812v8.437a2.813,2.813,0,0,1-5.625,0V70.31A2.812,2.812,0,0,1,70.31,67.5ZM56.251,64.685V84.372H84.375V64.685ZM29.82,42.186A24.128,24.128,0,0,0,5.62,66.193a6.971,6.971,0,0,0,7,6.93h38V59.061H78.313l.076-.233a8.617,8.617,0,0,0,.358-2.472,8.436,8.436,0,1,0-16.872-.163l-5.628.056.006-.214a14.159,14.159,0,0,1,2.435-7.654l.319-.45-.013-.012A24.2,24.2,0,0,0,43.3,42.186ZM36.561,5.625a15.457,15.457,0,0,0-4.278,30.349,15.934,15.934,0,0,0,8.558,0,15.457,15.457,0,0,0-4.28-30.349Zm0-5.625A21.056,21.056,0,0,1,50.612,36.885l-.528.448.2.045a29.755,29.755,0,0,1,12.681,6.535l.245.22.479-.271a13.925,13.925,0,0,1,6.621-1.677,14.132,14.132,0,0,1,14.062,14.17,14.428,14.428,0,0,1-.148,2.067l-.108.638H90V90H50.626V78.748h-38A12.6,12.6,0,0,1,0,66.193,29.718,29.718,0,0,1,22.376,37.5l.663-.161-.525-.445A21.057,21.057,0,0,1,36.561,0Z",
    transform: "translate(6 11.46)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiabilidadDitoPay);
export default __webpack_public_path__ + "static/media/Confiabilidad Dito Pay.297e2d46b54bd26c5fcdbb17324b7789.svg";
export { ForwardRef as ReactComponent };